module.exports = __webpack_public_path__ + "img/instagram-logo-16x16.91b89955.svg";